import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import React, { useContext, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import ErrorBox from 'components/message-boxes/error-box/ErrorBox'
import { IApplicationContext } from 'interfaces/i-application-context-props'
import { ApplicationDispatchContext } from 'contexts/ApplicationContext'
import { getDeviceData } from 'utils/commonhelpers'
import pnServices from 'services/pnServices'
import { IAcceptOffer } from 'interfaces/i-accept-offer'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import { InfoBox } from 'components/message-boxes/information-box/InformationBox'
import { MarketingPreferences } from './MarketingPreferences'

export const PreliminaryPnUK = () => {
	const { t } = useTranslation()
	const { loanApplication }: IApplicationContext = useContext(
		ApplicationDispatchContext,
	)
	const applicationId = loanApplication.applicationData?.loanNumber!
	const { msp, dispatchMsp } = useContext(MspDispatchContext)

	const [actionLoading, setActionLoading] = useState(false)
	const [actionError, setActionError] = useState(false)

	async function acceptOffer() {
		setActionLoading(true)
		try {
			const acceptOfferData: IAcceptOffer = {
				firstName:
					loanApplication.applicationData?.personalInfo?.firstName,
				lastName:
					loanApplication.applicationData?.personalInfo?.lastName,
				timestamp: new Date().toISOString(),
				apr: loanApplication.applicationData?.apr!,
				creditLimit: loanApplication.applicationData?.creditLimit!,
				// ssn: undefined, // we don't have ssn, and it's not mandatory in the px ep anyway, so we skip this
				// ipAddress: undefined, // this will be populated in CDA
				deviceData: getDeviceData(),
				applicationId: applicationId,
			}

			await pnServices.acceptOffer(acceptOfferData)

			next()
		} catch (error) {
			console.warn(error)
			setActionError(true)
			setActionLoading(false)
		}
	}

	const next = () => {
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: {
				index: msp.index + 1,
			},
		})
	}

	const backBtnClick = async () => {
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: {
				index: msp.index - 1,
			},
		})
	}

	if (actionLoading) {
		return (
			<div className="col-spinner">
				<CircleSpinner />
			</div>
		)
	}

	const errorMessage =
		loanApplication.applicationData?.apr === undefined ||
		loanApplication.applicationData?.creditLimit === undefined
			? t('ErrorMissingOfferData')
			: actionError
				? t('ErrorMsg')
				: undefined

	if (errorMessage) {
		return (
			<div className="error-box-container">
				<ErrorBox message={errorMessage} />
			</div>
		)
	}

	return (
		<div className="sign-pn-view-contract-section">
			<div className="sign-pn-description">
				<div>
					<Trans t={t} i18nKey={'OfferReviewInfo'}></Trans>
				</div>
			</div>
			<MarketingPreferences />
			<p className="marketing-preferences-footer">
				{t('MarketingPreferencesFooter')}
			</p>
			<a href="https://google.com" target="_blank">
				{t('PrivacyPolicyLinkText')}
			</a>
			<InfoBox
				infoType="info"
				css="avarda-info"
				message={
					<>
						<strong>{t('HardSearchHeader')}</strong>
						<br />
						{t('HardSearchDescription')}
					</>
				}
			/>

			<div className="step-actions sign-pn-button-section">
				<button
					type="button"
					className="btn btn-secondary"
					onClick={() => {
						setTimeout(() => {
							backBtnClick()
						}, 400)
					}}>
					{t('Back')}
				</button>
				&nbsp;
				<button
					id="accept-offer-uk-button"
					type="button"
					className="btn btn-primary"
					onClick={() => {
						setTimeout(() => {
							acceptOffer()
						}, 400)
					}}>
					{t('Continue')}
				</button>
			</div>
		</div>
	)
}
